var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuesadilla(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20280_301550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 0H0V500H500V0Z",
    fill: "#DDB19E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 143.8C38 155.8 49.8 239.9 93.7 263.7C204.8 323.9 204.4 397 194.7 500H0V143.8Z",
    fill: "#DCC0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.2 0H500V500H417.4C331 400.3 418.2 261.7 287.2 0Z",
    fill: "#DCC0AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M249.9 446.6C342.629 446.6 417.8 415.573 417.8 377.3C417.8 339.027 342.629 308 249.9 308C157.171 308 82 339.027 82 377.3C82 415.573 157.171 446.6 249.9 446.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4 302.3C85.9 253.3 167.1 221.2 249.9 221.2C332.7 221.2 413.9 253.3 435.4 302.3C463.3 366 384.2 433.7 249.9 433.7C115.6 433.7 36.5 366 64.4 302.3Z",
    fill: "#A6A5C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4 294.8C85.9 245.8 167.1 213.7 249.9 213.7C332.7 213.7 413.9 245.8 435.4 294.8C463.3 358.5 384.2 426.2 249.9 426.2C115.6 426.2 36.5 358.5 64.4 294.8Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.2 294C145.8 262.9 197.3 242.6 249.8 242.6C302.3 242.6 353.8 263 367.4 294C385.1 334.4 334.9 377.4 249.8 377.4C164.7 377.4 114.5 334.4 132.2 294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.7 299.3C286.2 296.6 246.2 268.7 221.1 247.1C204.4 232.2 180.9 209.1 186.1 184.4C193.8 152.6 245.6 142 273 135.1C278.6 133.7 284.2 132.5 289.7 131C290.4 130.8 291.8 130.4 292.4 130.1C314.9 122.4 327.6 88.7 308 71.9C302.4 67.2 295.2 64.6 287.8 63.3C280 62 271.5 62.1 263 63C247.6 64.1 245.2 42.2 260.5 39.9C281.5 38.5 305.6 41.3 321.9 56.6C348.9 81.7 336.6 127.2 305.3 142.4C301.6 144.2 297.6 145.6 293.7 146.6C266.1 152.7 236.7 155.4 211.9 169.6C201.2 175.9 193.5 185.5 196.4 198.4C202.7 226.5 245.7 260.3 269.4 276.3C282.9 285 297.4 292.9 313.1 296.8C315.3 297.3 317.7 297.8 319.9 298C320.3 298 320.5 298.4 320.5 298.7C320.3 299.1 320 299.4 319.7 299.3Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.4 240.3C343.9 268.2 288.6 251.3 222.8 224.3C157 197.3 137 174.9 144.7 147.7C163.8 79.8 180.2 139.5 246.3 167.2C311.9 194.6 366.9 212.4 355.4 240.3Z",
    fill: "#D39F53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.2 238.5C344.7 266.4 289.4 249.5 223.6 222.5C157.8 195.5 137.8 173.1 145.5 145.9C164.6 78 181 137.7 247.1 165.4C312.7 192.8 367.7 210.6 356.2 238.5Z",
    fill: "#EFC178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.9 227C245.3 225.9 135.6 167 159.8 166.9C182.1 166.7 221.6 203 233.5 202.4C277.1 200.3 304.9 222.4 351.5 216.3C367.8 214.2 326.4 259.5 247.9 227Z",
    fill: "#FCFC8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.8 141.7C203.8 141.7 177 127.9 164.6 140.3C152.2 152.7 147.3 159.9 174.1 165.5C200.9 171.1 231 185.3 233 176.5C235 167.7 203.8 141.7 203.8 141.7Z",
    fill: "#FCFC8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.1 179.2C214.1 179.2 177.4 160.1 191.7 179.3C206 198.5 236.1 205.2 249.1 210.5C262.1 215.9 292.7 210.4 274.8 203.6C257 196.8 214.1 179.2 214.1 179.2Z",
    fill: "#FCFC8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.035 166.943C195.428 161.119 191.363 153.93 183.956 150.886C176.548 147.843 168.603 150.096 166.21 155.92C163.817 161.744 167.882 168.933 175.29 171.976C182.697 175.02 190.642 172.767 193.035 166.943Z",
    fill: "#DA6A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.809 197.69C243.202 191.867 239.137 184.678 231.73 181.634C224.322 178.59 216.377 180.844 213.984 186.668C211.591 192.491 215.656 199.68 223.063 202.724C230.471 205.768 238.416 203.514 240.809 197.69Z",
    fill: "#A50A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.056 151.201C204.505 147.676 199.674 142.351 192.266 139.307C184.859 136.263 177.68 136.653 176.231 140.178C174.783 143.703 179.613 149.028 187.021 152.072C194.428 155.116 201.608 154.726 203.056 151.201Z",
    fill: "#A50A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.455 232.956C319.848 227.132 315.783 219.943 308.376 216.899C300.968 213.856 293.023 216.109 290.63 221.933C288.237 227.757 292.302 234.946 299.709 237.989C307.117 241.033 315.062 238.78 317.455 232.956Z",
    fill: "#DA6A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.1 196C273.1 196 246.3 182.2 233.9 194.6C221.5 207 216.6 214.2 243.4 219.8C270.2 225.4 300.3 239.6 302.3 230.8C304.3 221.9 273.1 196 273.1 196Z",
    fill: "#EDE974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.84 192.344C221.233 186.52 217.168 179.331 209.76 176.287C202.353 173.243 194.408 175.497 192.015 181.321C189.621 187.144 193.686 194.333 201.094 197.377C208.501 200.421 216.446 198.167 218.84 192.344Z",
    fill: "#DA6A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.513 211.934C255.541 209.431 252.482 205.802 247.68 203.828C242.878 201.855 238.151 202.285 237.123 204.788C236.094 207.291 239.153 210.92 243.955 212.893C248.757 214.867 253.484 214.437 254.513 211.934Z",
    fill: "#DA6A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.6 217.6C379.2 250.6 342.5 247.8 276.8 220.8C211.1 193.8 169.8 181.4 181.2 153.5C192.7 125.6 140.7 104.6 206.5 131.6C272.3 158.6 342 176.9 362.6 217.6Z",
    fill: "#D39F53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.2 216.5C381.8 249.5 345.1 246.7 279.4 219.7C213.7 192.7 172.4 180.3 183.8 152.4C195.2 124.5 133.5 99.6 199.3 126.6C265.1 153.6 344.6 175.8 365.2 216.5Z",
    fill: "#FED68A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.06 157.213C227.214 154.403 222.601 149.845 215.755 147.032C208.909 144.219 202.424 144.216 201.27 147.026C200.115 149.836 204.728 154.394 211.574 157.207C218.42 160.02 224.905 160.023 226.06 157.213Z",
    fill: "#EFC178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.829 165.606C254.395 164.227 252.08 161.969 248.657 160.562C245.234 159.156 242 159.134 241.434 160.513C240.867 161.892 243.182 164.151 246.605 165.557C250.028 166.964 253.262 166.986 253.829 165.606Z",
    fill: "#EFC178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.396 179.301C299.962 177.921 297.647 175.663 294.224 174.257C290.802 172.85 287.567 172.828 287.001 174.207C286.434 175.587 288.749 177.845 292.172 179.252C295.595 180.658 298.829 180.68 299.396 179.301Z",
    fill: "#EFC178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.325 199.054C288.892 197.675 287.985 195.995 286.299 195.302C284.613 194.61 282.787 195.166 282.22 196.546C281.654 197.925 282.561 199.605 284.247 200.297C285.932 200.99 287.759 200.434 288.325 199.054Z",
    fill: "#EFC178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.743 182.681C238.309 181.301 237.402 179.622 235.716 178.929C234.031 178.236 232.204 178.793 231.638 180.172C231.071 181.551 231.978 183.231 233.664 183.924C235.35 184.617 237.176 184.06 237.743 182.681Z",
    fill: "#EFC178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.195 210.396C341.762 209.016 339.447 206.758 336.024 205.352C332.601 203.945 329.367 203.923 328.8 205.302C328.233 206.682 330.549 208.94 333.971 210.347C337.394 211.753 340.628 211.775 341.195 210.396Z",
    fill: "#EFC178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.3 294.9C412.8 334.4 337.9 348.3 244.7 356.6C151.5 364.9 114.5 350.9 106.9 314.6C87.9999 223.7 143.3 283.5 237.4 275.7C330.7 268 405.8 255.4 409.3 294.9Z",
    fill: "#D39F53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1 292.3C412.6 331.8 337.7 345.7 244.5 354C151.3 362.3 114.3 348.3 106.7 312C87.8 221.1 143.1 280.9 237.2 273.1C330.5 265.3 405.5 252.8 409.1 292.3Z",
    fill: "#EFC178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.5 344.8C271.8 345.1 107.9 342.9 136.1 328C162 314.3 230.1 332.7 243.7 324.8C293.4 295.8 339.3 304.9 390 269.5C407.9 257 387 335 275.5 344.8Z",
    fill: "#FCFC8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.3 271.8C172.3 271.8 132.6 271.9 125.7 293.9C118.8 315.9 117.4 327.3 152.1 317.5C186.8 307.7 230.6 306.1 227.6 294.6C224.6 283.1 172.3 271.8 172.3 271.8Z",
    fill: "#FCFC8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.1 309.3C207.1 309.3 152.6 309.2 181 323C209.4 336.8 248.5 326.3 267 324.6C285.5 322.9 317.9 298 292.8 300.9C267.7 303.8 207.1 309.3 207.1 309.3Z",
    fill: "#FCFC8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.143 308.235C152.649 307.295 160.564 299.8 159.821 291.493C159.078 283.187 149.959 277.216 139.452 278.156C128.946 279.096 121.031 286.591 121.774 294.897C122.517 303.203 131.637 309.175 142.143 308.235Z",
    fill: "#A50A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.739 336.136C249.245 335.196 257.16 327.7 256.417 319.394C255.674 311.088 246.554 305.117 236.048 306.057C225.542 306.997 217.627 314.492 218.37 322.798C219.113 331.104 228.233 337.076 238.739 336.136Z",
    fill: "#A50A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.041 318.034C372.547 317.094 380.462 309.599 379.719 301.293C378.976 292.986 369.856 287.015 359.35 287.955C348.843 288.895 340.928 296.39 341.671 304.696C342.415 313.002 351.534 318.974 362.041 318.034Z",
    fill: "#A50A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.344 324.532C167.851 323.592 175.766 316.097 175.023 307.791C174.279 299.485 165.16 293.513 154.653 294.453C144.147 295.393 136.232 302.888 136.975 311.195C137.718 319.501 146.838 325.472 157.344 324.532Z",
    fill: "#DA6A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.74 326.134C353.246 325.194 361.161 317.699 360.418 309.392C359.675 301.086 350.555 295.115 340.049 296.055C329.543 296.995 321.628 304.49 322.371 312.796C323.114 321.102 332.234 327.074 342.74 326.134Z",
    fill: "#DA6A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2 293.2C286.2 293.2 246.5 293.3 239.6 315.3C232.7 337.3 231.3 348.7 266 338.9C300.7 329.1 344.5 327.5 341.5 316C338.4 304.5 286.2 293.2 286.2 293.2Z",
    fill: "#EDE974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.842 338.632C213.348 337.692 221.263 330.197 220.52 321.891C219.777 313.585 210.657 307.613 200.151 308.553C189.644 309.493 181.729 316.988 182.472 325.295C183.216 333.601 192.335 339.572 202.842 338.632Z",
    fill: "#DA6A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.373 330.57C269.194 329.96 274.464 326.567 274.144 322.991C273.824 319.416 268.035 317.012 261.214 317.622C254.393 318.232 249.123 321.626 249.443 325.201C249.763 328.777 255.552 331.18 262.373 330.57Z",
    fill: "#DA6A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.9 264.1C443.4 292.5 398.7 311.6 305.5 319.9C212.3 328.2 156.5 338.8 153 299.2C149.5 259.6 76.0999 266.6 169.3 258.3C262.5 250.1 355.1 229 403.9 264.1Z",
    fill: "#D39F53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.3 261.3C445.8 289.7 401.1 308.8 307.9 317.1C214.7 325.4 158.9 336 155.4 296.4C151.9 256.9 64.6 265.2 157.8 256.8C251 248.5 357.5 226.1 406.3 261.3Z",
    fill: "#FED68A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.735 285.062C200.416 284.196 207.977 280.284 207.623 276.323C207.269 272.362 199.133 269.854 189.452 270.72C179.771 271.586 172.21 275.499 172.564 279.459C172.918 283.42 181.054 285.929 190.735 285.062Z",
    fill: "#EFC178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.718 273.779C241.558 273.346 245.339 271.39 245.162 269.409C244.984 267.429 240.917 266.175 236.076 266.608C231.235 267.041 227.455 268.997 227.632 270.978C227.809 272.958 231.877 274.212 236.718 273.779Z",
    fill: "#EFC178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.31 261.983C303.151 261.55 306.932 259.594 306.754 257.613C306.577 255.633 302.51 254.379 297.669 254.812C292.828 255.245 289.048 257.201 289.225 259.182C289.402 261.162 293.47 262.416 298.31 261.983Z",
    fill: "#EFC178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.718 291.482C304.138 291.266 305.957 289.485 305.779 287.505C305.602 285.525 303.497 284.095 301.076 284.311C298.656 284.528 296.837 286.309 297.015 288.289C297.192 290.269 299.297 291.699 301.718 291.482Z",
    fill: "#EFC178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.812 302.979C235.232 302.763 237.051 300.982 236.873 299.002C236.696 297.021 234.591 295.592 232.17 295.808C229.75 296.025 227.931 297.805 228.109 299.786C228.286 301.766 230.391 303.196 232.812 302.979Z",
    fill: "#EFC178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.011 272.983C370.852 272.55 374.633 270.594 374.455 268.614C374.278 266.633 370.21 265.379 365.37 265.812C360.529 266.245 356.749 268.202 356.926 270.182C357.103 272.162 361.171 273.416 366.011 272.983Z",
    fill: "#EFC178"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20280_301550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuesadilla);
export default __webpack_public_path__ + "static/media/Quesadilla.13e51289.svg";
export { ForwardRef as ReactComponent };